import clsx from "clsx";
import { useNavigate, useParams } from "react-router-dom";
import { Progress } from "../../../shared/src/components/progress";
import translate from "../locales";
import { useCallback, useEffect, useState, useRef } from "react";

const TELLIT_URLS = {
  dienstverlening: "d88bc8daab388ec3d61133bb",
  dialoog: "98273d5812720aff0b306b57",
  buurten: "eee8e819242ee90ded13be2c",
};

export function TellitPage({ handleSave, children, className, page }) {
  const navigate = useNavigate();
  const { theme } = useParams();
  const formRef = useRef(null);
  const tellitRef = useRef(null);

  useEffect(() => {
    if (formRef.current === null) return;

    if (page.treesponse.getAnswer("action") !== undefined) {
      const callback = () => setTimeout(scrollToForm, 25);
      tellitRef.current?.addEventListener("tellit:loaded", callback, {
        once: true,
      });
      scrollToForm();

      return () =>
        tellitRef.current?.removeEventListener("tellit:loaded", callback, {
          once: true,
        });
    }
  }, [formRef]);

  function scrollToForm() {
    formRef.current.scrollIntoView({ behaviour: "instant", block: "start" });
  }

  return (
    <>
      <Progress
        onBackButton={() => navigate("/")}
        step={1}
        title={translate([theme, "name"])}
        prevAria={translate(["general", "prev_page_aria"])}
      />
      <ScrollIndicator />
      <tellit-player
        data-story-url={`https://tell-it-production-public.s3.eu-central-1.amazonaws.com/${TELLIT_URLS[theme]}/story.json`}
        ref={tellitRef}
      ></tellit-player>
      <form
        action=""
        onSubmit={handleSave}
        className={clsx(className, "tellit-form")}
        data-theme={theme}
        ref={formRef}
      >
        <div className="tellit-form__container">
          {children}
          <button className="tellit-form__action" type="submit">
            {translate(["general", "next_page"])}
          </button>
        </div>
      </form>
    </>
  );
}

const SCROLL_INDICATOR_UNTIL = 250;

function ScrollIndicator() {
  const [hidden, setHidden] = useState(window.scrollY > SCROLL_INDICATOR_UNTIL);

  const onScroll = useCallback(() => {
    setHidden(window.scrollY > SCROLL_INDICATOR_UNTIL);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <div className="scroll-indicator" hidden={hidden}>
      <p className="scroll-indicator__text">
        {translate("general.scroll_down")}
      </p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="currentColor"
        className="scroll-indicator__icon"
        aria-hidden="true"
      >
        <path d="M8.00024 12.696L4.00024 8.69603L4.93358 7.7627L8.00024 10.8127L11.0669 7.7627L12.0002 8.69603L8.00024 12.696ZM8.00024 8.69603L4.00024 4.69603L4.93358 3.7627L8.00024 6.8127L11.0669 3.7627L12.0002 4.69603L8.00024 8.69603Z" />
      </svg>
    </div>
  );
}
